import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { catchError, EMPTY, map } from 'rxjs';

import { environment } from '../../environments/environment';

type Response = {
  body?: string;
};

@Injectable({
  providedIn: 'root',
})
export class ApiClientService {
  private http = inject(HttpClient);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  public signIn(props: { email: string; password: string }) {
    return this.getCsrf();
  }

  private getCsrf() {
    return this.http
      .get(environment.apiAuthUrl, {
        observe: 'response',
        headers: {
          Accept: 'text/html',
          'Content-type': 'text/html',
          'Response-Type': 'text',
        },
      })
      .pipe(
        map((resp: HttpResponse<Response>) => {
          const csrf = /csrf_token.*?value="(.*?)"/.exec(resp.body?.body || '');
          return csrf && csrf[1] ? csrf[1] : 'no-token';
        }),
        catchError(error => {
          console.error(error);
          return EMPTY;
        }),
      );
  }
}
